/**
 * Whether this browser belongs to a HEGIAS account.
 *
 * Cached locally because the app needs to decide whether to offer the Details
 * control on the error page - and the usual source of that fact, /users/me,
 * needs the very backend that just failed.
 *
 * This is a rendering hint, never an authorisation decision. The server checks
 * a signed token claim on every /health/detailed call, so a hand-set flag buys
 * a button that answers 403.
 */
export const STAFF_FLAG_KEY = "hegias_staff";

export const isStaffFlagSet = (): boolean => {
	try {
		return window.localStorage.getItem(STAFF_FLAG_KEY) === "true";
	} catch {
		// Private browsing, or storage blocked by policy.
		return false;
	}
};
